<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <b-avatar
        size="30"
        variant="light-primary"
        badge
        :src="avatar"
        class="badge-minimal"
        badge-variant="success"
      />
    </template>

    <b-dropdown-header link-class="d-flex align-items-center">
      <span style="padding: 10px; text-align: center; display: block; font-size: 11px;">{{ this.userName }}</span>
    </b-dropdown-header>

    <b-dropdown-divider />

    <b-dropdown-item link-class="d-flex align-items-center" @click.prevent="$router.push({ path: '/profile' })">
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>Profil</span>
    </b-dropdown-item>

    <b-dropdown-item link-class="d-flex align-items-center" @click.prevent="$router.push({ path: '/setting' })" v-if="this.settingAllow == true">
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span>Configuration société</span>
    </b-dropdown-item>

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click.prevent="logout()"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>Se déconnecter</span>
    </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BDropdownHeader
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
import { avatarText } from '@core/utils/filter'
import PouchDB from 'pouchdb'


export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BDropdownHeader
  },
  data() {
    return {
      avatar: require('@/assets/images/avatars/picto-user.png'),
      userName: '',
      userLog: localStorage.getItem('user'),
      userRole: localStorage.getItem('role'),
      commercial: '',
      settingAllow: '',
      remoteDB: new PouchDB(localStorage.getItem('url')+'/'+localStorage.getItem('database'), { skip_setup: true }),
      role: localStorage.getItem('role'),
    }
  },
  created() {
    this.commercial = JSON.parse(localStorage.commercial)
    // Vérification Role
    if (this.role.includes('admin'+localStorage.getItem('database')) || this.role.includes('manager'+localStorage.getItem('database'))) {
      this.settingAllow = true
    }
    else {
      this.settingAllow = false
    }

    // Vérification Avatar
    if (!this.commercial.avatar) {
      this.avatar = require('@/assets/images/avatars/picto-user.png')
    }
    else {
      this.avatar = this.commercial.avatar
    }
    // Vérification nom & prénom
    if(!this.commercial.nom && !this.commercial.prenom) {
      this.userName = localStorage.getItem('user')
    }
    else if (!this.commercial.nom) {
      this.userName = this.commercial.prenom
    }
    else if (!this.commercial.prenom) {
      this.userName = this.commercial.nom
    }
    else {
      this.userName = this.commercial.nom + ' ' + this.commercial.prenom
    }
  },
  methods: {
    logout() {
      // this.remoteDB = new PouchDB('https://couchdb.placedusite.fr/palmero', { skip_setup: true })
      this.remoteDB.logOut(response => {
        console.log('logout', response)
        localStorage.removeItem('user')
        localStorage.removeItem('role')
        localStorage.removeItem('commercial')
        localStorage.removeItem('setting')
        localStorage.removeItem('userData')
        this.$router.push({ path: '/login' })
      })
    },
  },
}
</script>

<style>
.dropdown-user .dropdown-menu {
    min-width: 200px !important;
}
</style>